import { createAsyncThunk } from "@reduxjs/toolkit"
import { Plan } from "@/types"
import { httpGet } from "@/lib/http"

export const fetchActivePlans = createAsyncThunk<Plan[], void, { rejectValue: string }>(
  "plans/fetchActive",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const res = await httpGet({ url: 'plans/active', dispatch })
      const data = res?.data
      if (!Array.isArray(data)) return []
      return data.map((p: any) => ({
        id: p.id,
        planId: p.planId,
        name: p.title || p.name || p.planId,
        title: p.title,
        tier: p.tier,
        duration: p.duration,
        durationInDays: p.durationInDays,
        price: p.price,
        monthlyCost: p.monthlyCost,
        active: p.active,
        icon: p.icon,
        features: [p.description, p.humor, p.notes].filter(Boolean),
        description: p.description,
        humor: p.humor,
        notes: p.notes,
        badge: p.badge || null,
      })) as Plan[]
    } catch (error: any) {
      return rejectWithValue(error.message)
    }
  }
)
